import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { X, PanelTop } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { Button } from '@/components/ui/button';
export const WebviewContainer = ({ webview, onClick }) => {
    const [hideLoader, setHideLoader] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const handleMessage = (event) => {
            var _a, _b;
            if (event.source !== ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contentWindow)) {
                return;
            }
            const isCloseMessage = event.data === 'closeModal' ||
                (typeof event.data === 'object' &&
                    ((_b = event.data) === null || _b === void 0 ? void 0 : _b.type) === 'moveo-close-webview');
            if (isCloseMessage) {
                onClick();
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onClick]);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "min-h-full overflow-hidden rounded-[var(--moveo-new-border-radius-base)] border border-border bg-background", children: [_jsxs("div", { className: "flex w-full items-center justify-between border-b border-border px-4 pb-2 pt-3", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(PanelTop, { size: 16 }), _jsx("p", { className: "text-sm leading-6", children: webview.name })] }), _jsx(Button, { variant: "ghost", size: "icon", onClick: onClick, children: _jsx(X, { className: "h-5 w-5 text-accent" }) })] }), _jsx("span", { className: cn('flex min-h-[calc(100%-44px)] items-center justify-center', {
                        hidden: hideLoader,
                    }), children: _jsx(LoadingIcon, {}) }), _jsx("iframe", { allow: "geolocation", ref: ref, id: webview.action_id, title: webview.name, src: webview.url, onLoad: () => setHideLoader(true), className: cn('h-[calc(100%-44px)] w-full', {
                        hidden: !hideLoader,
                    }) })] }) }));
};
